import './QuizQuestionTypeOption.scoped.scss';

export interface QuizQuestionTypeOptionInterface {
  id?: string;
  name: string;
  alias: string;
  path?: string;
  imagePath: string;
}

interface QuizQuestionTypeOptionProps {
  questionType: QuizQuestionTypeOptionInterface;
  onClick: () => void;
}

const QuizQuestionTypeOption: React.FC<QuizQuestionTypeOptionProps> = ({
  questionType,
  onClick,
}) => {
  return (
    <div className="quiz-question-type" onClick={onClick}>
      <div className="quiz-question-type-icon-wrapper">
        <img alt="Quiz question type icon" src={questionType.imagePath} />
      </div>

      <p className="quiz-question-type-description">{questionType.name}</p>
    </div>
  );
};

export default QuizQuestionTypeOption;
